export const facets = [
    { name: "status", field: "status" },
    { name: "type", field: "type" },
    { name: "created_by", field: "created_by" },
    { name: "total", field: "total" },
]

export const COLLECTIONS_FACETS = [
    { name: "created_by", field: "created_by" },
    { name: "updated_by", field: "updated_by" },
    { name: "dynamic", field: "dynamic" },
    { name: "status", field: "properties.status" },
]
